import React from "react";
import { Chip, ChipOption, ChipSizeEnum } from "../Chip/Chip";
import { CollaboratorInfo } from "../../../types/AppTypes";
import { capitalize } from "../../../utils/string.utils";
import {
  StyledContentDownloadCollaboratorChip,
  StyledNameDownloadCollaboratorChip,
} from "./DownloadCollaboratorChip.styled";

type DownloadCollaboratorChipProps = {
  collaborator: CollaboratorInfo;
  borderColor?: string;
  backgroundColor?: string;
};

export const DownloadCollaboratorChip = ({
  collaborator,
  borderColor,
  backgroundColor,
}: DownloadCollaboratorChipProps) => {
  const content: ChipOption<number> = {
    value: collaborator.id,
    label: (
      <StyledContentDownloadCollaboratorChip>
        <StyledNameDownloadCollaboratorChip>
          {capitalize(`${collaborator.surname} ${collaborator.name}`)}
        </StyledNameDownloadCollaboratorChip>
      </StyledContentDownloadCollaboratorChip>
    ),
  };

  return (
    <Chip
      option={content}
      borderColor={borderColor}
      backgroundColor={backgroundColor}
      size={ChipSizeEnum.X_SMALL}
      fullWidth
      readonly
    />
  );
};
